import React from 'react';
import PropTypes from 'prop-types';

import DocumentModal from './document_modal.jsx';
import DocumentStoreItem from '../../models/document_store_item';
import DocumentModalIds from '../../constants/document_modal_ids';

import { DocumentActions } from '../../reflux/document_store';

export default class HandleDivergentDocumentVersionsModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		title: 'template.titles.handleDivergentVersions',
		className: 'handle-divergent-document-versions-modal',
		store: new DocumentStoreItem(),
	};

	render() {
		return (
			<div className="handle-divergent-document-versions__content">
			<div className="handle-divergent-document-versions row">
			<p className="col s12 row">
			{Realize.i18n.t('template.messages.handleDivergentVersions')}
			</p>
			</div>
			</div>
		);
	}
}
